<template>
  <el-row v-loading="loading" class="pond-feed-tab">
    <el-row type="flex" justify="space-between">
      <el-col :span="7">
        <!-- :key="selectedPondDetails._id" -->
        <!-- <er-date-picker
          size="small"
          :key="selectedPondDetails._id"
          v-model="dateRangeSelected"
          value-format="yyyy-MM-dd"
          :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
          type="daterange"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="initComponent"
        ></er-date-picker> -->
      </el-col>
    </el-row>
    &nbsp;
    <el-row>
      <el-col>
        <er-card>
          <er-data-tables
            :tableData="tableData"
            :key="$i18n.locale"
            :columns="tableColumns"
            type="white-header-table"
            uniqueId="dealer-table"
            :action-column="false"
          >
            <template v-slot:date="{ row }">{{
              $moment(row.data.date).format("DD-MMM-YY")
            }}</template>
            <template v-slot:green_colonies="{ row }">{{
              row.data.green_colonies | numberWithNDigitPrecision(0)
            }}</template>
            <template v-slot:yellow_colonies="{ row }">{{
              row.data.yellow_colonies | numberWithNDigitPrecision(0)
            }}</template>
            <template v-slot:ph="{ row }">{{
              row.data.ph | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:salinity="{ row }">{{
              row.data.salinity | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:do="{ row }">{{
              row.data.do | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:co3="{ row }">{{
              row.data.co3 | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:hco3="{ row }">{{
              row.data.hco3 | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:alkallnity_total="{ row }">{{
              row.data.alkallnity_total | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:hardness="{ row }">{{
              row.data.hardness | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:ammonia="{ row }">{{
              row.data.ammonia | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:iron="{ row }">{{
              row.data.iron | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:actions="{ row }">
              <er-button
                type="text"
                size="mini"
                btnType="edit"
                :showLabel="true"
                :showIcon="true"
                @click="handleEditRecord(row.data)"
                :disabled="clickable"
              ></er-button>
              <el-divider
                direction="vertical"
                style="height:100%;"
              ></el-divider>
              <er-button
                type="text"
                size="mini"
                btnType="delete"
                :showLabel="true"
                :showIcon="true"
                @click="handleDeleteRecord(row.data)"
                :disabled="clickable"
              ></er-button>
            </template>
          </er-data-tables>
        </er-card>
      </el-col>
    </el-row>
    <er-dialog
      :visible.sync="dialogVisible"
      width="25%"
      :close-on-click-modal="false"
      class="pond-input-tab"
      custom-class="pondInput_dialog"
      :title="`${$t('Comn_update')} ${$t('Comn_inputs')}`"
    >
      <el-form size="small" :model="editLabRec" :hide-required-asterisk="true">
        <!-- ph, -->
        <el-form-item :label="$t('Comn_ph')">
          <el-col :span="22">
            <el-input
              v-model="editLabRec.ph"
              :controls="false"
              size="mini"
              :error="castErrorKeyToLang(errMessagesObject.ph)"
            ></el-input>
          </el-col>
        </el-form-item>
        <!-- salinity, -->
        <el-form-item :label="$t('Comn_salinity_ppt')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.salinity"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- do, -->
        <el-form-item :label="$t('Comn_do')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.do"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- co3, -->
        <el-form-item :label="$t('Comn_co3')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.co3"
              :controls="false"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- hco3, -->
        <el-form-item :label="$t('Comn_hco3')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.hco3"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- alkallnity_total,  -->
        <el-form-item :label="$t('Comn_total')">
          <el-col :span="22">
            <el-input-number
              :value="parseInt(editLabRec.hco3) + parseInt(editLabRec.co3)"
              :controls="false"
              :disabled="true"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- hardness, -->
        <el-form-item :label="$t('Comn_hardness_ppm')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.hardness"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- ammonia, -->
        <el-form-item :label="$t('Comn_ammonia_nh4')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.ammonia"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- iron, -->
        <el-form-item :label="$t('Comn_iron')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.iron"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- green_colonies, -->
        <el-form-item :label="$t('Comn_green_colonies')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.green_colonies"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <!-- yellow_colonies -->
        <el-form-item :label="$t('Comn_yellow_colonies')">
          <el-col :span="22">
            <el-input-number
              v-model="editLabRec.yellow_colonies"
              :controls="false"
              :min="0"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-form-item>
      </el-form>
      <layout-toolbar slot="footer" justify="center">
        <er-button
          size="mini"
          btnType="save"
          :showLabel="true"
          :showIcon="true"
          :loading="loading"
          @click="decideActionAndPrepPayload()"
          :disabled="isReadOnly"
        ></er-button>
        <er-button
          size="mini"
          btnType="cancel"
          :showLabel="true"
          @click="closeDialogBox"
          :disabled="isReadOnly"
        ></er-button>
      </layout-toolbar>
    </er-dialog>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import errorKeyMapMixin from "@/mixins/errorKeyMapMixin";
import notificationMixin from "@/mixins/notificationMixin";

export default {
  name: "pondLabTestsTab",
  props: ["tabData"],
  mixins: [errorHandlerMixin, errorKeyMapMixin, notificationMixin],
  data: function() {
    return {
      dateRangeSelected: [],
      loading: true,
      dialogVisible: false,
      editLabRec: {
        ph: 0,
        salinity: 0,
        do: 0,
        co3: 0,
        hco3: 0,
        alkallnity_total: 0,
        hardness: 0,
        ammonia: 0,
        iron: 0,
        green_colonies: 0,
        yellow_colonies: 0
      },
      newErrObject: {
        ph: ""
      },
      errMessagesObject: {
        ph: ""
      },
      backndfieldToFieldNameMap: {
        ph: "Resource_Lab_Name"
      },
      backndfieldToInvalidMap: {
        ph: {
          FIELD_REQUIRED: "Comn_name"
        }
      }
    };
  },

  computed: {
    ...mapGetters("pondDetails", {
      getPondIdPondMap: "getPondIdPondMap",
      getCurrentCulture: "getCurrentCulture",
      pondId: "getSelectedPondId",
      getSelectedPondLabTests: "getSelectedPondLabTests"
    }),
    ...mapGetters("user", {
      getUserLocations: "getUserLocations",
      getCurrUserLocation: "getCurrUserLocation",
      getUserTimeZoneOffset: "getUserTimeZoneOffset",
      isReadOnly: "isReadOnly"
    }),

    PondsObj: function() {
      return this.getPondIdPondMap;
    },
    selectedPondDetails() {
      return this.PondsObj[this.pondId];
    },
    pickerOptions: function() {
      return {
        disabledDate: date => {
          const start_date = this.$moment(
            this.getCurrentCulture.start_date
          ).valueOf();
          const end_date = this.$moment(
            this.getCurrentCulture.end_date
          ).valueOf();
          return !(date.getTime() >= start_date && date.getTime() <= end_date);
        }
      };
    },
    tableData() {
      return this.getSelectedPondLabTests;
    },
    tableColumns() {
      return {
        ph: {
          label: this.$t("Comn_ph"),
          prop: "ph"
        },
        salinity: {
          label: this.$t("Comn_salinity_ppt"),
          prop: "salinity"
        },
        do: {
          label: this.$t("Comn_do"),
          prop: "do"
        },
        co3: {
          label: this.$t("Comn_co3"),
          prop: "co3"
        },
        hco3: {
          label: this.$t("Comn_hco3"),
          prop: "hco3"
        },
        alkallnity_total: {
          label: this.$t("Comn_total"),
          prop: "alkallnity_total"
        },
        hardness: {
          label: this.$t("Comn_hardness_ppm"),
          prop: "hardness"
        },
        ammonia: {
          label: this.$t("Comn_ammonia_nh4"),
          prop: "ammonia"
        },
        iron: {
          label: this.$t("Comn_iron"),
          prop: "iron"
        },
        date: {
          label: this.$t("Comn_date"),
          prop: "date",
          minWidth: 100
        },
        green_colonies: {
          label: this.$t("Comn_green_colonies"),
          prop: "green_colonies"
        },
        yellow_colonies: {
          label: this.$t("Comn_yellow_colonies"),
          prop: "yellow_colonies"
        },
        actions: {
          label: "Actions",
          prop: "actions",
          minWidth: 150
        }
      };
    },
    clickable() {
      return !this.isReadOnly && !this.getCurrentCulture.is_running;
    }
  },
  async mounted() {
    // this.initDate();
    await this.initComponent();
  },
  methods: {
    ...mapActions("pondDetails", {
      fetchLabTestsByPondId: "fetchLabTestsByPondId"
    }),
    ...mapActions("labTests", {
      addLabTests: "addLabTests",
      deleteLabTest: "deleteLabTest"
    }),
    initDate() {
      this.dateRangeSelected = [
        this.$moment
          .utc(this.getCurrentCulture.start_date)
          .format("YYYY-MM-DD"),
        this.$moment.utc(this.getCurrentCulture.end_date).format("YYYY-MM-DD")
      ];
    },
    async initComponent() {
      try {
        await this.fetchLabTestsByPondId();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleEditRecord(editLabRec) {
      try {
        this.isEditable(this.tabData);
        this.errMessagesObject = this.$lodash.cloneDeep(this.newErrObject);
        this.dialogVisible = true;
        this.editLabRec = JSON.parse(JSON.stringify(editLabRec));
      } catch (error) {
        // this.errorMessages(error, true);
        console.log(error);
      }
    },
    getValidationError(record) {
      console.log(record);
      if (!record.ph && record.ph != 0) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: "pH"
          })}`
        };
      } else if (!record.salinity && record.salinity != 0) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: this.$t("Comn_salinity")
          })}`
        };
      } else if (!record.do && record.do != 0) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: "DO"
          })}`
        };
      } else {
        return {};
      }
    },
    validatePayload(labRec) {
      if (this.getValidationError(labRec).message) {
        throw {
          type: "FAIL_TO_SAVE",
          errors: [this.getValidationError(labRec)]
        };
      } else {
      }
    },
    async decideActionAndPrepPayload() {
      this.loading = true;
      try {
        this.validatePayload(this.editLabRec);

        this.editLabRec.lab_id = this.editLabRec.lab_id._id;
        console.log(this.editLabRec.co3, this.editLabRec.hco3);
        this.editLabRec.alkallnity_total =
          !this.editLabRec.co3 &&
          this.editLabRec.co3 != 0 &&
          !this.editLabRec.hco3 &&
          this.editLabRec.hco3 != 0
            ? 0
            : parseInt(this.editLabRec.co3) + parseInt(this.editLabRec.hco3);
        let payload = {
          lab_tests: [this.editLabRec]
        };

        await this.addLabTests(payload);

        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("Lab_tests_created_success"),
          duration: 5000,
          type: "success"
        });
        this.closeDialogBox();
      } catch (err) {
        const errors = [];
        if (err.errors && err.errors.length > 0) {
          this.errorMessages(err, true);
        } else if (err.response && err.response.data.errors != null) {
          err.response.data.errors.details.forEach((el, index) => {
            errors.push({ message: el.message });
          });
          this.errorFailToSave(errors);
        } else if (err.response && err.response.data.message) {
          errors.push({ message: err.response.data.message });
          this.errorFailToSave(errors);
        } else {
          this.errorMessages(err, true);
        }
      } finally {
        await this.initComponent();
        this.loading = false;
      }
    },
    closeDialogBox() {
      this.dialogVisible = false;
    },
    async handleDeleteRecord(record) {
      try {
        this.canUserDelete(this.tabData);
        await this.deleteConfirmation(
          this.$t("Comn_resource"),
          this.$t("Comn_inputs")
        );
        this.loading = true;
        await this.deleteLabTest(record._id);
        this.$notify({
          title: this.$t("Comn_record_delete_success_msg"),
          message: this.$t("Lab_tests_deleted_success"),
          duration: 5000,
          type: "success"
        });
        await this.initComponent();
      } catch (err) {
        if (err !== "cancel") {
          this.errorMessages(err, true);
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.pond-feed-tab {
  .el-form-item__label {
    width: 145px;
  }
}
</style>
